import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

const SPARKLES = [
  { top: "12%", left: "8%", size: 4, delay: 0 },
  { top: "22%", left: "78%", size: 3, delay: 0.4 },
  { top: "68%", left: "14%", size: 3, delay: 0.8 },
  { top: "45%", left: "92%", size: 5, delay: 1.2 },
  { top: "82%", left: "55%", size: 3, delay: 0.6 },
  { top: "8%", left: "42%", size: 3, delay: 1.5 },
  { top: "58%", left: "68%", size: 4, delay: 0.2 },
  { top: "35%", left: "24%", size: 2, delay: 1.8 },
  { top: "75%", left: "88%", size: 3, delay: 1.0 },
  { top: "18%", left: "58%", size: 2, delay: 2.1 },
  { top: "90%", left: "22%", size: 3, delay: 0.9 },
  { top: "48%", left: "48%", size: 2, delay: 1.4 },
];

/**
 * Soft twinkling sparkles — editorial, not noisy.
 */
export const SparkleField = ({ count = 12, className = "" }) => {
  const reduced = usePreferStaticUI();
  const items = SPARKLES.slice(0, count);

  if (reduced) return null;

  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {items.map((s, i) => (
        <motion.span
          key={i}
          className="absolute rounded-full bg-raspberry/70"
          style={{
            top: s.top,
            left: s.left,
            width: s.size,
            height: s.size,
            boxShadow: `0 0 ${s.size * 3}px rgba(158, 74, 98, 0.35)`,
          }}
          animate={{
            opacity: [0.15, 0.85, 0.2],
            scale: [0.6, 1.2, 0.7],
          }}
          transition={{
            duration: 2.8 + (i % 3) * 0.6,
            repeat: Infinity,
            ease: "easeInOut",
            delay: s.delay,
          }}
        />
      ))}
    </div>
  );
};

export default SparkleField;
